<template>
  <div class="mainfooter _mainfooter">
    <div class="footerbottom _footerbottom">
      <p>Copyright @2021 Champion Aviation Dynamic Technology (China) Co., Ltd, All rights reserved.
      </p>
    </div>

  </div>
</template>

<script>
  import {getContactsMeList} from '@/api/home';

  export default {
    name: 'mainfooter',
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .mainfooter {
      flex-direction: column;
      width: 100%;
      height:10%;
      background: #0D2334;
      align-items: center;
      color: white;

      .footerbottom {
        padding: 20px 0;

        p {
          font-size: 0.9em;
        }
      }
    }

  }

  @media only screen and (max-width: 800px) {
    ._mainfooter {
      /*position: relative;*/
      /*display: flex;*/
      flex-direction: column;
      width: 100%;
      background: #0F2538;
      align-items: center;
      color: white;
      font-size: 1em;

      .footerbottom {
        padding: 10px 0;
        bottom: 0;
        p {
          font-size: 1em;

        }
      }


    }
  }

</style>



// WEBPACK FOOTER //
// src/views/comcomponents/Footer.vue